import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import Voicemail from './icon-voicemail.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <Voicemail {...validProps} />;
}
SvgComponent.iconName = 'voicemail';

/**
 * @deprecated This is a legacy icon
 */
export const VoicemailIcon = svgIconWrapper(SvgComponent);
